<template>
  <div class="parameterBlock">
    <div class="parameterBlock-head">
      <h3><slot /></h3>
      <div class="parameterBlock-head__toggle" v-if="showToggle" @click="isOpen = !isOpen">
        <span class="toggle" :class="{ open: isOpen }"></span>
      </div>
    </div>
    <div class="parameterBlock-content" v-show="isOpen">
      <div
        class="parameterBlock-content__keyValue"
        v-for="(item, name, index) in content"
        :key="index"
      >
        <div v-show="isVisible(item.ruleSubscriber, item.target)">
          <div class="label-container">
            <span>{{ item.label }}</span>
            <span class="label__sub" v-if="item.subLabel">{{ item.subLabel }}</span>
          </div>

          <animated-content
            :value="isNumber(item.value, item.hideFractionDigits) || item.value || '--'"
            :unit="item.unit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _isString from 'lodash/isString';
import AnimatedContent from './animatedContent';

export default {
  name: 'ParameterBlock',
  components: { AnimatedContent },
  props: {
    content: {
      type: Array,
      default: () => []
    },
    showToggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: true
    };
  },
  computed: {
    ...mapGetters(['getRule'])
  },
  methods: {
    isNumber(value, fractions) {
      if (!isNaN(value) && !_isString(value)) {
        // The two strings are configured in main.js and determine how many
        // fractionDigits have to be shown.
        const decimalConfig = fractions ? 'noDecimals' : 'withDecimals';
        return this.$n(value, decimalConfig);
      }
      return value;
    },

    isVisible(rule, target) {
      if (rule && target) {
        if (target === 'hidden') {
          return !this.getRule(rule);
        }
      }
      return true;
    }
  }
};
</script>

<style scoped lang="scss">
.parameterBlock {
  h3 {
    @include unitSmall;
    color: $greeny-blue;
  }

  &-head {
    position: relative;

    &__toggle {
      width: 50px;
      height: 50px;
      position: absolute;
      top: -25px;
      right: -25px;
      display: flex;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }

    .toggle {
      margin: 12px 0 0;

      &:after {
        background: url(../../assets/img/ico-expand-list.svg) center center no-repeat;
        transform: rotate(0deg);
        content: '';
        height: 20px;
        width: 20px;
        float: right;
      }

      &.open {
        &:after {
          transform: rotate(180deg);
        }
      }
    }
  }

  &-content {
    margin-top: 8px;
    // padding: 0 0 0 20px;
    padding: 0;

    &__keyValue > div {
      display: flex;
      padding: 4px 0;

      .label-container,
      .value-container {
        flex: 1;
        @include breakpoint(md) {
          flex: 0 0 65%;
        }

        > span {
          @include textCharts;
          color: $bluey-grey;
          display: inline-block;
          // word-break: break-all;

          &.label__sub {
            display: block;
            color: $charcoal-grey;
          }
        }
      }

      .value-container {
        text-align: right;
        flex: 1;
        @include breakpoint(md) {
          flex: 0 0 45%;
        }

        span {
          color: $petrol;
        }
      }
    }
  }
}
</style>
